var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.06066V12.9957C8 14.5632 6.8525 15.9582 5.2925 16.1082C3.5 16.2807 2 14.8782 2 13.1232V3.85316C2 2.87066 2.705 1.97816 3.68 1.88066C4.805 1.76816 5.75 2.64566 5.75 3.74816V11.6232C5.75 12.0357 5.4125 12.3732 5 12.3732C4.5875 12.3732 4.25 12.0357 4.25 11.6232V5.06066C4.25 4.75316 3.995 4.49816 3.6875 4.49816C3.38 4.49816 3.125 4.75316 3.125 5.06066V11.5182C3.125 12.5007 3.83 13.3932 4.805 13.4907C5.93 13.6032 6.875 12.7257 6.875 11.6232V3.87566C6.875 2.30816 5.7275 0.913156 4.1675 0.763156C2.3825 0.590656 0.875 1.99316 0.875 3.74816V12.9507C0.875 15.1032 2.45 17.0307 4.595 17.2332C7.0625 17.4582 9.125 15.5382 9.125 13.1232V5.06066C9.125 4.75316 8.87 4.49816 8.5625 4.49816C8.255 4.49816 8 4.75316 8 5.06066Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAttach);
export default __webpack_public_path__ + "static/media/file_attach.eafc3754fff01a039aa6a8787881ea20.svg";
export { ForwardRef as ReactComponent };